import { Button } from "@mui/joy";
import { useApplicants } from "context/ApplicantsContext";
import { CheckCircleOutline } from "@mui/icons-material";

interface MeetButtonProps {
  candidate: any;
}

const MeetButton: React.FC<MeetButtonProps> = ({ candidate }) => {
  const { addApplicantId, removeApplicantId, isSelected } = useApplicants();

  const isApplicantSelected = isSelected(candidate.uuid);

  const handleMeet = () => {
    addApplicantId(candidate.uuid);
  };

  const handleUnselect = () => {
    removeApplicantId(candidate.uuid);
  };

  if (isApplicantSelected) {
    return (
      <Button 
        onClick={handleUnselect}
        size="sm"
        variant="outlined"
        color="success"
        startDecorator={<CheckCircleOutline />}
        sx={{
          color: '#45a049',
          borderColor: '#45a049',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          '&:hover': {
            backgroundColor: 'rgba(76, 175, 80, 0.2)',
          }
        }}
      >
        Selected
      </Button>
    );
  }

  return (
    <Button 
      onClick={handleMeet}
      size="sm"
      variant="solid"
    >
      Meet
    </Button>
  );
};

export default MeetButton; 